(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[521],{

/***/ 512:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__(6075);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ImageGliph; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_1__);


function ImageGliph(param) {
    var src = param.src;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "glyph-image-container",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            layout: "raw",
            width: "200",
            height: "200",
            src: "/assets/animated-glyphs/".concat(src, ".gif")
        })
    });
}


/***/ }),

/***/ 6075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ About; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var components_MetaTags__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8992);
/* harmony import */ var components_Elements_Container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4721);
/* harmony import */ var components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7603);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(965);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8494);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5935);
/* harmony import */ var strapi_api__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1014);
/* harmony import */ var _react_hook_mouse_position__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2061);
/* harmony import */ var components_Elements_ImageGlliph__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4318);













var TeamMemberCard = function(param) {
    var data = param.data;
    var photo = data.photo, name = data.name, position = data.position;
    var card = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref = (0,_react_hook_mouse_position__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(card, {
        leaveDelay: 300
    }), x = ref.x, y = ref.y;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "relative !bg-transparent image-container",
        ref: card,
        children: [
            (data === null || data === void 0 ? void 0 : data.line) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    left: x && x + 25,
                    top: y && y
                },
                className: "absolute z-50 px-6 py-3 uppercase transition-opacity duration-500 bg-white border-2 border-black opacity-0 team-member-slide-tooltip text-16",
                children: data === null || data === void 0 ? void 0 : data.line
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                src: strapi_api__WEBPACK_IMPORTED_MODULE_12__/* ["default"].getNextImage */ .Z.getNextImage(photo, "large"),
                objectFit: "cover",
                layout: "fill",
                loading: "eager",
                alt: ""
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                className: "mt-2 leading-6 text-16 768:text-18 1280:text-22",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        className: "uppercase animated-border dark-border thin-border",
                        children: [
                            name,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "absolute top-0 left-0 w-full h-full"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        children: position
                    })
                ]
            })
        ]
    });
};
var Modal = function(param) {
    var data = param.data, isModalOpen = param.isModalOpen, closeModal = param.closeModal;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                onClick: closeModal,
                className: "close-overlay fixed w-screen h-screen z-50 top-0 left-0 bg-white/60 transition-opacity duration-500 \n                ".concat(isModalOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("aside", {
                id: "members-modal",
                className: "fixed h-screen top-0 bg-white z-50 py-4 px-5 transition-all duration-500 overflow-y-auto 768:border-r-2 border-black ".concat(isModalOpen ? "left-0" : "-left-full"),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex items-start justify-between w-full",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "mb-2 leading-none uppercase fluid-type",
                                        children: data === null || data === void 0 ? void 0 : data.name
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                        className: "leading-none ",
                                        children: data === null || data === void 0 ? void 0 : data.position
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                onClick: closeModal,
                                className: "leading-6 uppercase text-16 768:text-18 1280:text-22 animated-border dark-border thin-border",
                                children: "close"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        id: "member-description",
                        className: "pb-6 mt-5 leading-snug 768:mt-16 991:mt-24 indent-10 768:indent-20 1024:indent-24 content-with-glyphs",
                        children: data && (0,html_react_parser__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(data.bio)
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
function About(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isModalOpen = ref[0], setIsModalOpen = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), modalData = ref1[0], setModalData = ref1[1];
    var closeModal = function() {
        setIsModalOpen(false);
    };
    var openModal = function() {
        setIsModalOpen(true);
    };
    var handleKeyPress = function(event) {
        if (event.keyCode === 27) {
            setIsModalOpen(false);
        }
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        document.addEventListener("keydown", handleKeyPress, {
            passive: true
        });
    }, []);
    var navigationSlideshowStudioPrev = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var navigationSlideshowStudioNext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var navigationSlideshowTeamPrev = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var navigationSlideshowTeamNext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_MetaTags__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                title: props.meta_info && props.meta_info.meta_title ? props.meta_info.meta_title : "ABOUT US",
                description: props.meta_info && props.meta_info.meta_description ? props.meta_info.meta_description : "ABOUT US - ZANAD | An Independent Animation Production Studio",
                image: props.meta_info && props.meta_info.og_image ? strapi_api__WEBPACK_IMPORTED_MODULE_12__/* ["default"].getNextImage */ .Z.getNextImage(props.meta_info.og_image, "large") : "/public/og-image.jpg"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        className: "offscreen-title",
                        children: props.meta_info && props.meta_info.meta_title ? props.meta_info.meta_title : "ABOUT US"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Modal, {
                        data: modalData,
                        isModalOpen: isModalOpen,
                        closeModal: closeModal
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Elements_Container__WEBPACK_IMPORTED_MODULE_3__/* .ContainerWithOffset */ .jZ, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "mt-8 mb-6 uppercase fluid-type",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        num: 1,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "flex flex-row justify-start",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "optical-align letter-d",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                        num: 5,
                                                        children: "Down "
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                        num: 1.5,
                                                        children: "with"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                        num: 3.5,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_ImageGlliph__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                            src: "MARGIN_HAND"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                        num: 6,
                                                        children: "anything"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        num: 2,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "flex flex-row justify-start",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                        num: 2,
                                                        children: "that "
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                        num: 4.5,
                                                        children: "moves "
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                        num: 7,
                                                        children: "ideas"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        num: 3,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "flex flex-row justify-end",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "inline-block optical-align letter-p",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                        num: 3.5,
                                                        children: "people "
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                        num: 1,
                                                        children: "and "
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                        num: 6.5,
                                                        children: "brands"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        num: 4,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "flex flex-row justify-end",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                        num: 5,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_ImageGlliph__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                            src: "MARGIN_CAT"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                        num: 1,
                                                        children: "forward."
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mb-6 leading-tight text-20 768:text-30 1024:text-40 1280:text-48 indent-10 768:indent-20 1024:indent-36 1280:indent-48 content-with-glyphs",
                                children: props.content.lead ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(props.content.lead) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                            })
                        ]
                    }),
                    props.content.gallery ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .Swiper */ .tq, {
                        modules: [
                            swiper__WEBPACK_IMPORTED_MODULE_5__/* .Navigation */ .W_
                        ],
                        spaceBetween: 0,
                        slideToClickedSlide: true,
                        grabCursor: true,
                        navigation: {
                            prevEl: navigationSlideshowStudioPrev.current,
                            nextEl: navigationSlideshowStudioNext.current
                        },
                        onBeforeInit: function(swiper) {
                            swiper.params.navigation.prevEl = navigationSlideshowStudioPrev.current;
                            swiper.params.navigation.nextEl = navigationSlideshowStudioNext.current;
                        },
                        slidesPerView: "auto",
                        className: "mb-6 studio-slideshow carousel group",
                        children: [
                            props.content.gallery.data.map(function(slide, i) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {
                                    className: "relative !bg-transparent image-container",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_7___default()), {
                                        src: "https://zanad.tv" + slide.attributes.url,
                                        objectFit: "cover",
                                        layout: "fill",
                                        loading: "eager",
                                        alt: ""
                                    })
                                }, i);
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "absolute z-10 w-full px-5 transition-opacity -translate-y-1/2 opacity-0 pointer-events-none navigation-wrapper top-1/2 768:px-8 duration-400 group-hover:opacity-100",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        ref: navigationSlideshowStudioPrev,
                                        className: "cursor-pointer pointer-events-auto slideshow-control prev-control",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                            width: "52",
                                            height: "52",
                                            viewBox: "0 0 52 52",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                                    cx: "26",
                                                    cy: "26",
                                                    r: "25",
                                                    fill: "white",
                                                    stroke: "black",
                                                    strokeWidth: "2"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                    d: "M22.7319 36.9628L13.186 27.4168C12.6002 26.831 12.6002 25.8813 13.186 25.2955L22.7319 15.7496L24.8532 17.8709L17.868 24.8562L38.4658 24.8562L38.4658 27.8562L17.868 27.8562L24.8532 34.8414L22.7319 36.9628Z",
                                                    fill: "black"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        ref: navigationSlideshowStudioNext,
                                        className: "absolute top-0 cursor-pointer pointer-events-auto slideshow-control next-control right-4 768:right-8",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                            width: "52",
                                            height: "52",
                                            viewBox: "0 0 52 52",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                                    cx: "26",
                                                    cy: "26",
                                                    r: "25",
                                                    transform: "rotate(-180 26 26)",
                                                    fill: "white",
                                                    stroke: "black",
                                                    strokeWidth: "2"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                    d: "M29.2681 15.0372L38.814 24.5832C39.3998 25.169 39.3998 26.1187 38.814 26.7045L29.2681 36.2504L27.1468 34.1291L34.132 27.1438L13.5342 27.1438L13.5342 24.1438L34.132 24.1438L27.1468 17.1586L29.2681 15.0372Z",
                                                    fill: "black"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Elements_Container__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "grid gap-4 mb-24 640:gap-12 768:gap-10 1024:gap-16 640:grid-cols-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                        className: "uppercase fluid-type",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                num: 1,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "block optical-align letter-o",
                                                    children: "Our"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                num: 2,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "block text-right 768:text-left 768:indent-20 1024:indent-40 1280:indent-56",
                                                    children: "process"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "max-w-screen-md leading-tight text-16 768:text-18 1280:text-22 content-with-glyphs",
                                        children: props.content.process ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(props.content.process) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mb-6",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                    className: "uppercase fluid-type",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            num: 1,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "block 768:indent-20 1024:indent-40 1280:indent-56 optical-align letter-o",
                                                children: "Our"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                            num: 2,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "block text-right 768:text-left optical-align letter-d",
                                                children: "people"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    props.content.team ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .Swiper */ .tq, {
                        modules: [
                            swiper__WEBPACK_IMPORTED_MODULE_5__/* .Navigation */ .W_
                        ],
                        spaceBetween: 0,
                        preventClicks: false,
                        navigation: {
                            prevEl: navigationSlideshowTeamPrev.current,
                            nextEl: navigationSlideshowTeamNext.current
                        },
                        onBeforeInit: function(swiper) {
                            swiper.params.navigation.prevEl = navigationSlideshowTeamPrev.current;
                            swiper.params.navigation.nextEl = navigationSlideshowTeamNext.current;
                        },
                        slidesPerView: "auto",
                        className: "mb-16 team-slideshow carousel 1024:mb-24 group",
                        children: [
                            props.content.team.map(function(member) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {
                                    className: "team-member-slide hover:z-10",
                                    onClick: function() {
                                        openModal();
                                        setModalData(member);
                                    },
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TeamMemberCard, {
                                        data: member
                                    })
                                }, member.id);
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "absolute z-10 w-full px-5 transition-opacity -translate-y-1/2 opacity-0 pointer-events-none navigation-wrapper top-1/2 768:px-8 duration-400 768:group-hover:opacity-100",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        ref: navigationSlideshowTeamPrev,
                                        className: "absolute top-0 cursor-pointer pointer-events-auto slideshow-control prev-control left-4 768:left-8",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                            width: "52",
                                            height: "52",
                                            viewBox: "0 0 52 52",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                                    cx: "26",
                                                    cy: "26",
                                                    r: "25",
                                                    fill: "white",
                                                    stroke: "black",
                                                    strokeWidth: "2"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                    d: "M22.7319 36.9628L13.186 27.4168C12.6002 26.831 12.6002 25.8813 13.186 25.2955L22.7319 15.7496L24.8532 17.8709L17.868 24.8562L38.4658 24.8562L38.4658 27.8562L17.868 27.8562L24.8532 34.8414L22.7319 36.9628Z",
                                                    fill: "black"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        ref: navigationSlideshowTeamNext,
                                        className: "absolute top-0 cursor-pointer pointer-events-auto slideshow-control next-control right-4 768:right-8",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                                            width: "52",
                                            height: "52",
                                            viewBox: "0 0 52 52",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                                                    cx: "26",
                                                    cy: "26",
                                                    r: "25",
                                                    transform: "rotate(-180 26 26)",
                                                    fill: "white",
                                                    stroke: "black",
                                                    strokeWidth: "2"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                    d: "M29.2681 15.0372L38.814 24.5832C39.3998 25.169 39.3998 26.1187 38.814 26.7045L29.2681 36.2504L27.1468 34.1291L34.132 27.1438L13.5342 27.1438L13.5342 24.1438L34.132 24.1438L27.1468 17.1586L29.2681 15.0372Z",
                                                    fill: "black"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Elements_Container__WEBPACK_IMPORTED_MODULE_3__/* .Container */ .W2, {
                        children: [
                            props.content.clients ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "grid gap-4 mb-24 -mt-20 640:gap-12 768:gap-10 1024:gap-16 640:grid-cols-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                        className: "uppercase fluid-type",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                num: 1,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "block 768:indent-56 1024:indent-68 1280:indent-96",
                                                    children: "Our"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                num: 2,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "block text-right 768:text-left optical-align letter-c",
                                                    children: "clients"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "leading-tight break-all text-15 414:text-16 768:text-18 1280:text-22 columns-2 gap-x-0 414:gap-x-1 content-with-glyphs",
                                        children: (0,html_react_parser__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(props.content.clients)
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                            props.content.awards ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "grid gap-4 mb-6 640:gap-12 768:gap-10 1024:gap-16 640:grid-cols-2",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                        className: "uppercase fluid-type",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                num: 1,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "block optical-align letter-o",
                                                    children: "Our"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Elements_AnimatedBox__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                                num: 2,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "block text-right 768:text-left 768:indent-20 1024:indent-48 1280:indent-64",
                                                    children: "awards"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "leading-tight text-15 414:text-16 768:text-18 1280:text-22 content-with-glyphs",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            children: props.content.awards ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .ZP)(props.content.awards) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {})
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,608,214,774,888,179], function() { return __webpack_exec__(512); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);